<script lang="ts">
  import { OFFSITE_LINKS } from '$lib/constants/strings';

  export let metafyType = 'Partner';
</script>

<p class="text-body-3xs text-ondark-subtle col-span-2 text-center">
  By signing up for Metafy <span class="capitalize">{metafyType.toLocaleLowerCase()}</span> you accept our
  <a href={OFFSITE_LINKS.terms} class="underline" target="_blank">terms</a> and
  <a href={OFFSITE_LINKS.privacy} class="underline" target="_blank">privacy policy</a>.
</p>
